import React from 'react';
import { Hero } from '../components/Hero';
import { PropertySearch } from '../components/PropertySearch';
import { MarketStats } from '../components/MarketStats';
import { Introduction } from '../components/Introduction';
import { AboutJenny } from '../components/AboutJenny';
import { Testimonials } from '../components/Testimonials';
import { Communities } from '../components/Communities';
import { MortgageCalculator } from '../components/MortgageCalculator';
import { HomeValuation } from '../components/HomeValuation';
import { RecentActivity } from '../components/RecentActivity';
import { WhyLasVegas } from '../components/WhyLasVegas';
import { FeaturedListings } from '../components/FeaturedListings';
import { FAQ } from '../components/FAQ';
import { ContactCTA } from '../components/ContactCTA';
import { SEOHead } from '../components/SEOHead';
export function HomePage() {
  return <main data-id="element-966">
      <SEOHead title="Jenny Gong | Las Vegas Luxury Real Estate Agent | Homes for Sale" description="Jenny Gong is a top Las Vegas real estate agent specializing in luxury homes for sale in Summerlin, Henderson, Southern Highlands, and MacDonald Highlands. Expert guidance for buyers and sellers in the Las Vegas Valley." keywords="Las Vegas real estate, Las Vegas realtor, luxury homes Las Vegas, homes for sale Las Vegas, Las Vegas real estate agent, Jenny Gong realtor, Henderson homes, Summerlin homes, Southern Highlands real estate, MacDonald Highlands, Green Valley homes, North Las Vegas real estate" canonicalUrl="https://jennygong.com/" ogImage="https://assets.cdn.filesafe.space/yOon1ID2yH9FCnnAGN2G/media/6228f759ced3001c58d1474b.png" schema={{
      '@context': 'https://schema.org',
      '@type': ['RealEstateAgent', 'LocalBusiness'],
      name: 'Jenny Gong - Love Las Vegas Realty',
      image: 'https://assets.cdn.filesafe.space/yOon1ID2yH9FCnnAGN2G/media/6228f759ced3001c58d1474b.png',
      url: 'https://jennygong.com',
      telephone: '+18583978218',
      email: 'jenny@jennygong.com',
      description: 'Jenny Gong is a dedicated Las Vegas real estate agent specializing in luxury homes across Summerlin, Henderson, Southern Highlands, MacDonald Highlands, Green Valley, Spring Valley, Southwest, and North Las Vegas.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '8400 W Sahara Ave',
        addressLocality: 'Las Vegas',
        addressRegion: 'NV',
        postalCode: '89117',
        addressCountry: 'US'
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 36.1447,
        longitude: -115.2839
      },
      areaServed: ['Las Vegas', 'Henderson', 'Summerlin', 'Southern Highlands', 'North Las Vegas', 'Spring Valley', 'Southwest Las Vegas', 'Green Valley', 'MacDonald Highlands'],
      priceRange: '$350,000 - $30,000,000',
      openingHours: 'Mo-Su 08:00-20:00',
      sameAs: []
    }} data-id="element-967" />
      <Hero data-id="element-968" />
      <PropertySearch data-id="element-969" />
      <MarketStats data-id="element-970" />
      <Introduction data-id="element-971" />
      <AboutJenny data-id="element-972" />
      <Testimonials data-id="element-973" />
      <Communities data-id="element-974" />
      <MortgageCalculator data-id="element-975" />
      <HomeValuation data-id="element-976" />
      <RecentActivity data-id="element-977" />
      <WhyLasVegas data-id="element-978" />
      <FeaturedListings data-id="element-979" />
      <FAQ data-id="element-980" />
      <ContactCTA data-id="element-981" />
    </main>;
}